
export class Profile {
  reference: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: number;
  picture: any;
  username: string;
  callCenter: any;
  address: string;
  role: any;
  lastConnexion: string;
  lastChangePassword: string;


  constructor( reference: string = null,
               firstname: string = null,
               lastname: string = null,
               email: string = null,
               phone: number = null,
               picture: string = null,
               username: string = null,
               callCenter: string= null,
               address: string = null) {
    this.reference = reference;
    this.firstname = firstname;
    this.lastname = lastname;
    this.email = email;
    this.phone = phone;
    this.picture = picture;
    this.username = username;
    this.callCenter = callCenter;
    this.address = address;
    this.role = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/profile.model.ts